// Configurações de ambiente
const params = typeof window !== 'undefined'
  ? new URLSearchParams(window.location.search)
  : new URLSearchParams();

const requestedProvider = params.get('provider');

if (typeof window !== 'undefined') {
  if (requestedProvider === 'vps' || requestedProvider === 'firebase') {
    sessionStorage.setItem('mediahub_provider_override', requestedProvider);
  }
}

const runtimeProvider = typeof window !== 'undefined'
  ? sessionStorage.getItem('mediahub_provider_override')
  : null;

export const ENV = {
  API_URL: import.meta.env.VITE_API_URL || 'https://api.mediahubapp.com',

  // VPS é o padrão de produção. O parâmetro ?provider=firebase mantém acesso controlado ao legado.
  MEDIA_PROVIDER: runtimeProvider || import.meta.env.VITE_MEDIA_PROVIDER || 'vps',
  AUTH_PROVIDER: runtimeProvider || import.meta.env.VITE_AUTH_PROVIDER || 'vps',

  APP_NAME: 'MediaHub',
  APP_VERSION: '1.0.0',

  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
};

export const USE_VPS_MEDIA = ENV.MEDIA_PROVIDER === 'vps';
export const USE_VPS_AUTH = ENV.AUTH_PROVIDER === 'vps';
